import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerSkillRequest extends BaseUpdateRequest{
    status: number;
}